import { Select } from 'antd'
import { useTranslation } from 'react-i18next'

import { useDashboardFilters } from '@contexts'
import { useCarriers } from '@hooks'

import { FilterGroup } from './styled'

const CarrierSelector = () => {
  const { t } = useTranslation()
  const { carrierId, setCarrierId } = useDashboardFilters()
  const { allCarriersOptions, isLoadingAllCarriers } = useCarriers({ disabled: false, limit: 1000 })

  return (
    <FilterGroup>
      <Select
        allowClear
        showSearch
        optionFilterProp="label"
        loading={isLoadingAllCarriers}
        style={{ minWidth: 200 }}
        placeholder={t('admin_router.dashboard.filter_carrier_all')}
        aria-label={t('admin_router.dashboard.filter_carrier')}
        options={allCarriersOptions}
        value={carrierId}
        onChange={value => setCarrierId(typeof value === 'number' ? value : undefined)}
      />
    </FilterGroup>
  )
}

export { CarrierSelector }
